import { useDroppable } from '@dnd-kit/core';
import { SortableContext, type SortingStrategy } from '@dnd-kit/sortable';
import { SortableItem } from './SortableItem';
import styled from '@emotion/styled';
import type { ColumnSelectorItem } from '../../types';
import { ReactNode } from 'react';

export type SortableContainerProps = {
  id: string;
  strategy: SortingStrategy;
  items: ColumnSelectorItem[];
  children?: ReactNode;
  tableId?: string;
};

export const SortableContainer = ({
  items,
  id,
  strategy,
  children,
  tableId,
}: SortableContainerProps) => {
  const { setNodeRef } = useDroppable({
    id,
  });

  return (
    <SortableContext id={id} items={items} strategy={strategy}>
      <SortableContainerList ref={setNodeRef}>
        <>
          {children}
          {items.map(column => (
            <SortableItem key={column.id} {...column} tableId={tableId} />
          ))}
        </>
      </SortableContainerList>
    </SortableContext>
  );
};

const SortableContainerList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding-left: 0;
`;
